import { render } from "./routeorangtua.vue?vue&type=template&id=78fd582c"
import script from "./routeorangtua.vue?vue&type=script&lang=js"
export * from "./routeorangtua.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__